import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DEBUG = false;
const ANIM_DURATION = 2;
const NUM_ATOMS_PER_RING = 2;
const NUM_RINGS = 3;

class MoleculeIcon extends React.Component {
  constructor(props) {
    super(props);

    this._icon = null;
    this._motionPaths = _.times(NUM_RINGS, () => null);
    this._atoms = _.times(6, () => null);
  }
  _initAnimations() {
    this._motionPaths.forEach((mp, i) => {
      const pathData = mp.getAttribute('d');

      const index1 = i * 2;
      const index2 = i * 2 + 1;
      const atoms = [this._atoms[index1], this._atoms[index2]];

      const bezierData = MorphSVGPlugin.pathDataToBezier(pathData, { align: atoms });

      TweenMax.set(atoms, {
        xPercent: -50,
        yPercent: -50,
        opacity: 1,
        bezier: {
          values: bezierData,
          type: 'cubic'
        }
      });

      _.times(NUM_ATOMS_PER_RING, j => {
        TweenMax.to(atoms[j], ANIM_DURATION, {
          bezier: {
            values: bezierData,
            type: 'cubic'
          },
          ease: Linear.easeNone,
          repeat: -1,
          yoyo: false,
          delay: (ANIM_DURATION * 0.5 * j) + (index1 * 0.2)
        });
      });

    });

  }
  componentDidMount() {
    this._initAnimations();
  }
  render() {
    const { centerColor, electronColor, ringColor, width, height } = this.props;

    return (
      <svg viewBox='0 0 100 100' width={width} height={height}>
        <g ref={icon => { this._icon = icon; }}>
          <circle
            ref={center => { this._center = center; }}
            r={3}
            cx={50}
            cy={50}
            fill={centerColor}/>
        </g>
        <g>
        {_.times(NUM_RINGS, i => (
          <path
            key={`motion-path-${i}`}
            style={{
              transform: `rotate(${i * 180 / NUM_RINGS}deg)`,
              transformOrigin: '50% 50%'
            }}
            ref={motionPath => { this._motionPaths[i] = motionPath; }}
            d={`M 5 50 c 5 -20, 95 -20, 90 0 s -90 20, -90 0`}
            fill={'none'}
            opacity={0.2}
            stroke={ringColor}
            strokeWidth={1} />
        ))}
        </g>
        <g>
          {_.times(NUM_RINGS, i => (
            <g key={`atom-ring-${i}`} transform={`rotate(${i * 180 / NUM_RINGS}, 50, 50)`}>
              {_.times(NUM_ATOMS_PER_RING, j => (
                <circle
                  key={`atom-${i}__${j}`}
                  style={{ opacity: 0 }}
                  ref={atom => { this._atoms[i * NUM_ATOMS_PER_RING + j] = atom; }}
                  r={2}
                  cx={5}
                  cy={50}
                  fill={electronColor} />
              ))}
            </g>
          ))}
        </g>
      </svg>
    );
  }
};

MoleculeIcon.propTypes = {
  centerColor: PropTypes.string,
  electronColor: PropTypes.string,
  ringColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

MoleculeIcon.defaultProps = {
  centerColor: 'black',
  electronColor: 'black',
  ringColor: 'black',
  width: 200,
  height: 200
};

export default MoleculeIcon;



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/MoleculeIcon.jsx